import React, { FunctionComponent, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all, fetch_all_with_count, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
import { currentPracticeAtom } from '../../../lib/practice';

import BuildIcon from '@mui/icons-material/Build';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import GroupsIcon from '@mui/icons-material/Groups';

import {
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Grid,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  DataGrid,
  Dt,
  Fab,
  IconButton,
  Page
} from '../../../components/v2/styled';
import { CardCourse } from '../../../components/v2/cards/Course';
import { SearchBox } from '../../../components/v2/SearchBox';
import { SnackDestroyed } from '../../../components/v2/snacks/Destroyed';

import { Consent } from '../../../models/Consent';
import { KnowledgeCourse } from '../../../models/KnowledgeCourse';

import HelpersLanguage from '../../../actions/helpers/language';

// const { DateTime } = require("luxon");

type Props = {}

export const CoachPublicKnowledgeCourses: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  let count = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("created_at DESC");
  const [search, setSearch] = useState<string>("");
  const [forPractice, setForPractice] = useState<number>();
  const [isNutri, setIsNutri] = useState<boolean>(false);

  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["coach", "knowledge_courses", (login?.id), {page: page, order: order, search: search, practice: forPractice, is_nutri: !!isNutri}],
    queryFn: () =>
      fetch_all_with_count<KnowledgeCourse>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'knowledge_course',
          fields: ['id', 'full_name', 'full_teaser', 'extra_data', 'get_item', 'is_bg_color', 'practice', 'knowsub', 'is_nutri', 'is_it'],
          sub_fields: {
            practice: ['id', 'name', 'get_item'],
            knowsub: ['id', 'created_at', 'lesson_key', 'lesson_data', 'is_approved', 'approved_at']
          },
          order: order,
          per_page: 200,
          page: page,
          filter: {
            search: search,
            advanced: {
              for_client: login?.id,
              for_practice: forPractice,
              ...(!!isNutri ? {
                is_nutri: 1
              } : {})
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!login?.id,
  });







  // const mutationDestroy = useMutation({
  //   mutationFn: (pars: {
  //     formData: any;
  //   }) => {
  //     return fetch_one<KnowledgeCourse>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
  //       pars.formData,
  //       login
  //     );
  //   },
  //   onMutate: (pars: {
  //     formData: any;
  //   }) => {
  //     return true;
  //   },
  //   onError: (data, variables, context) => {
  //     return true;
  //   },
  //   onSuccess: (data, variables, context) => {
  //     setDestroyedOpen(true);
  //     objectsRefetch();
  //   },
  // });








  return <Page
    title={t("coach.menu.knowledge_courses")}
    titleCrumbs={[
      {
        title: t("coach.menu.knowledge_center"),
        path: "/knowledge_center"
      }
    ]}
  >
    <SearchBox
      search={search}
      setSearch={setSearch}
      objectCount={count}
    />

    <Box sx={{textAlign: 'right', marginBottom: 1}}>
      <Chip
        label={t("client.knowledge.nutri_knowledge")}
        variant={!!isNutri ? "filled" : "outlined"}
        sx={{marginLeft: 1, cursor: 'pointer'}}
        color='primary'
        onClick={() => {
          if (!isNutri) setForPractice(undefined);
          setIsNutri(!isNutri);
        }}
      />
    </Box>

    {!!objectsLoading && <Box sx={{textAlign: 'center'}}>
      <CircularProgress />
    </Box>}

    <Grid container spacing={1}>
      {(objects || []).map(course => <Grid item xs={12} md={4}>
        <CardCourse
          course={course}
          coach
        />
      </Grid>)}
    </Grid>
  </Page>;
}
